<script setup lang="ts">
import type { ModelRef } from "vue";
import { OrganizationType } from "~/modules/organization/models/OrganizationType.enum";
import { UserColumns } from "~/modules/user/models/UserColumns.enum";

const { t } = useI18n();

const props = defineProps<{
  organizationCode: number;
  pathContext: string;
  organizationType?: OrganizationType;
  useExternalIdp?: boolean;
}>();

const showUserForm: ModelRef<boolean> = defineModel<boolean>("showUserForm", {
  required: true,
});
const currentSelectedUser: ModelRef<string | undefined> = defineModel<
  string | undefined
>("currentSelectedUser");
const columns: Ref<UserColumns[]> = ref<UserColumns[]>([
  UserColumns.LAST_NAME,
  UserColumns.FIRST_NAME,
  UserColumns.PROFILE,
  UserColumns.EMAIL,
  UserColumns.STATUS,
  UserColumns.ACTIONS,
]);
if (props.organizationType === OrganizationType.OPERATOR) {
  columns.value.push(UserColumns.GROUPS);
}
</script>

<template>
  <h4 class="mb-5 text-gray-900">
    {{ t("administration.organization.settings.users.title") }}
  </h4>
  <user-list
    v-model:show-user-form="showUserForm"
    v-model:current-selected-user="currentSelectedUser"
    :organization-code="organizationCode"
    :columns="columns"
    :organization-type="organizationType"
    :path-context="props.pathContext"
    :use-external-idp="useExternalIdp"
    use-query-parameters-for-pagination
  />
</template>
